import { CarouselFeature } from "./feature-base.js";
class SlideShowFeature extends CarouselFeature {
  constructor(host) {
    super(host);
    this.enabled = false;
    this.enableSlideShow = () => {
      if (this.enabled)
        this.disableSlideShow();
      const host = this.host;
      host.addEventListener("touchstart", this.handleTouchMove);
      host.addEventListener("click", this.handleTouchMove);
      host.addEventListener("wheel", this.handleTouchMove);
      this.enabled = true;
    };
    /** Disables Slide Show navigation support on the provided Carousel instance. */
    this.disableSlideShow = () => {
      const host = this.host;
      host.removeEventListener("touchstart", this.handleTouchMove);
      host.removeEventListener("click", this.handleTouchMove);
      host.removeEventListener("wheel", this.handleTouchMove);
      this.enabled = false;
    };
    this.handleTouchMove = (ev) => {
      const host = this.host;
      if (ev.composedPath().includes(host.scrollContainer)) {
        this.setManualMode(true);
        host.features.scroller.scroller.stopAnimations();
      } else {
        this.setManualMode();
      }
    };
    this.setManualMode = (toggle = false) => {
      this.host.scrollContainer.classList.toggle("manual-scroll", toggle);
    };
    this.host = host;
    host.gatherProperties(["slideShow"], host);
    Object.defineProperty(host, "slideShow", {
      get() {
        return host.hasAttribute("slide-show");
      },
      set(value) {
        host.toggleAttribute("slide-show", value);
      }
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "slide-show") {
      if (newValue !== null) {
        this.enableSlideShow();
      } else {
        this.disableSlideShow();
      }
    }
  }
  connectedCallback() {
    if (this.host.slideShow)
      this.enableSlideShow();
  }
  disconnectedCallback() {
    this.disableSlideShow();
  }
}
SlideShowFeature.observedAttributes = ["slide-show"];
export {
  SlideShowFeature
};
